




import { Vue, Component, Prop } from 'vue-property-decorator';
import { CompetencyType } from '@/constants/competencyType.enum';
import { GEnum } from '@/constants/enum.defination';

@Component({
  name: 'GCompetencyHeader',
  computed: {},
  methods: {},
})
export default class GCompetencyHeader extends Vue {
  @Prop() competencyType: GEnum.CompetencyType;
  mounted() {}

  get bgColorClass(): string {
    return CompetencyType.bgColorClass(this.competencyType);
  }
}
